//
//
//
//
//
//
//

import wrongImg from './images/wrong.png'
export default {
  data () {
    return {
      wrongImg
    }
  },
  created: async function () {
  }
}



// WEBPACK FOOTER //
// ./src/components/simple/appWrong/App-wrong.vue